export default [
    {
        path: '/personal_package/qa/main',
        name: '/personal_package/qa/main',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/qa/main')
    },
    {
        path: '/pages/personal_package/feedback/main',
        name: 'feedback',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/feedback/main')
    },
    {
        path: '/pages/personal_package/phone_call/main',
        name: 'phone_call',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/phone_call/main')
    },
    {
        path: '/pages/personal_package/verify_qualification/main',
        name: 'verify_qualification',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/verify_qualification/main')
    },
    {
        path: '/pages/personal_package/verify_qualification/verify/main',
        name: 'verify_qualification/verify',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/verify_qualification/verify/main')
    },
    {
        path: '/pages/personal_package/dora/main',
        name: 'dora',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/dora/main')
    },
    {
        path: '/pages/personal_package/inherit/main',
        name: 'inherit',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/personal_package/inherit/main')
    }
]